import { useState, useEffect } from 'react'
import { BROWSER } from '@/constant/env'
import throttle from 'lodash/throttle'

export default function useScroll(): Boolean {
  const [isScroll, setIsScroll] = useState(false)
  const scrollListener = () => {
    const scrollTop = document.getElementById('root')?.scrollTop || 0
    if (scrollTop > 0) {
      setIsScroll(true)
    } else {
      setIsScroll(false)
    }
  }

  const handleScroll = () => {
    if (!BROWSER) return
    scrollListener()
    window.addEventListener('scroll', throttle(scrollListener, 100), true)
  }

  const disconnectScroll = () => {
    if (!BROWSER) return
    window.removeEventListener('scroll', scrollListener, true)
  }

  useEffect(() => {
    handleScroll()
    return disconnectScroll
  }, [])

  return isScroll
}